export enum EAttendance {
  CONFIRMED = 'attendance-confirmed',
  REJECTED = 'attendance-rejected',
}
